import R from 'ramda';
import { createSelector } from 'reselect';

const getBasketProduct = createSelector(
  [
    (state) => state.content,
    (state) => state.selectedSwatch,
    (state) => state.retailerInfo,
  ],
  (content, selectedSwatch, retailerInfo) => {
    const selectedSku = R.prop('sku')(selectedSwatch);

    return {
      name: R.path(['productDetails', 'title'])(content),
      shadeName: R.prop('itemName')(selectedSwatch),
      price: R.path(['lowestPrice', 'number'])(retailerInfo),
      currency: R.path(['lowestPrice', 'currencySymbol'])(retailerInfo),
      image: R.compose(
        R.path(['images', 0, 'src']),
        R.find(R.propEq('sku', selectedSku)),
        R.prop('productGallery')
      )(content),
      ean: R.replace(/^0*/, '')(selectedSku),
      retailers: R.compose(
        R.filter((retailer) => !!retailer.inStock),
        R.map(
          ({
            name,
            displayName,
            logo,
            deepLinkUrl,
            price,
            sku,
            currencyCode,
            inStock,
          }) => ({
            name,
            displayName,
            logo,
            deepLinkUrl,
            price: R.replace(/[^0-9.-]+/g, '')(price),
            sku,
            currencyCode,
            inStock,
          })
        ),
        R.propOr([], 'retailersList'),
        R.find(R.propEq('sku', R.replace(/^0*/, '')(selectedSku))),
        R.prop('retailers')
      )(content),
      sku: selectedSku,
      productId: selectedSku,
      category: R.prop('categoryTitle', content),
      subcategory: R.prop('subcategoryTitle', content),
    };
  }
);

export { getBasketProduct };
